/**
 * UnreadThreadsNudge — dashboard banner that surfaces "N unread
 * conversations" from the provider↔client messaging system for the
 * CLIENT side (providers get a dedicated Messages tile in their
 * dashboard body instead). Renders nothing when there's nothing
 * unread — zero visual cost for users who never message anyone.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ChatCircleDotsIcon as ChatCircleDots, ArrowRightIcon as ArrowRight } from "@phosphor-icons/react";

export default function UnreadThreadsNudge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/provider-threads/unread-count")
      .then((r) => {
        if (!cancelled) setCount(r.data?.unread_threads || 0);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!count) return null;

  return (
    <Link
      to="/inbox/threads"
      className="flex items-center justify-between gap-3 rounded-2xl border border-[#E8D9A6] bg-[#FBF7EC] p-4 mb-6 hover:border-gold/60 transition-colors"
      data-testid="unread-threads-nudge"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-gold/15 flex-shrink-0">
          <ChatCircleDots size={18} weight="duotone" className="text-gold-dark" />
        </span>
        <p className="text-[13.5px] text-ink truncate">
          <strong>{count}</strong> unread conversation{count === 1 ? "" : "s"} waiting for your reply.
        </p>
      </div>
      <span className="text-[13px] text-ink inline-flex items-center gap-1 whitespace-nowrap">
        Open inbox <ArrowRight size={13} />
      </span>
    </Link>
  );
}
